<ll-titulo>{{ "usuarios_perfil_edit.titulo" | t | easyplaceholder: "Edición" }}</ll-titulo>

<ndc-dynamic 
    [ndcDynamicComponent]="component"
    [ndcDynamicInputs]="inputs"
></ndc-dynamic>